
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react'
import EmployeeMaster from '../EmployeeMaster/EmployeeMaster';

const Dashboard = () => {
    useEffect(() => {
        document.title = 'Viva HRMS: Dashboard'
        AOS.init(
            {
                duration: 1200,
            }
        );
    }, [])
    return (
        <>
            {/*
                <div className='container-fluid dashboard db-wrapper'>
                    <div className='row '>
                        <h2>Welcome To Viva HRMS</h2>
                    </div>
                </div>
            
                */}
            <EmployeeMaster/>
        </>

    )
}
export default Dashboard;